export default __webpack_public_path__ + "static/media/jester_white.5a769867.svg";